import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { getAdminAuditions } from "../../services/adminApi";
import ReusableAdminTable from "./ReusableAdminTable";
import useAuditionColumns from "./auditions/components/useAuditionColumns";

const AdminAuditionsList = () => {
    const [auditions, setAuditions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState("");

    const navigate = useNavigate();

    const loadAuditions = useCallback(async () => {
        setIsLoading(true);
        setError("");

        try {
            const res = await getAdminAuditions();
            const rawData = res?.data?.data || [];

            const mappedData = rawData.map((item) => ({
                id: item.roleApplicationId,
                roleId: item.roleId,
                applicationId: item.applicationId,
                roleApplicationId: item.roleApplicationId,
                candidateName: item.candidateName,
                castingDirector: item.castingDirector,
                roleName: item.roleName,
                auditionType: item.auditionType,
                paymentStatus: item.paymentStatus,
                paymentId: item.paymentId,
                auditionDate: item.auditionDate,
                auditionMonth: item.auditionMonth,
                verifyStatus: item.verifyStatus,
                status: item.status,
            }));

            setAuditions(mappedData);
        } catch (err) {
            console.error("Error loading auditions:", err);
            setError("Failed to load auditions.");
            setAuditions([]);
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        loadAuditions();
    }, [loadAuditions]);

    const handleViewApplication = useCallback((roleApplicationId) => {
        if (!roleApplicationId) {
            alert("Application ID not found.");
            return;
        }
        navigate(`/admin/manage-applications/${roleApplicationId}`);
    }, [navigate]);

    const columns = useAuditionColumns({ handleViewApplication });

    return (
        <ReusableAdminTable
            data={auditions}
            columns={columns}
            isLoading={isLoading}
            title="Auditions Management"
            searchPlaceholder="Search auditions..."
            exportCsvFilename="auditions-list.csv"
        />
    );
};

export default AdminAuditionsList;